/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Row, Col, Table } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import mPayment from './Payment.controller'


const Export = (props) => {
    const clientID = props.clientID
    const token = props.token
    const kodeoutlet = props.kodeoutlet
    const [isReload, setIsReload] = useState(true)
    const [listData, setListData] = useState([])
    useEffect(() => {
        mPayment.loadExport(kodeoutlet, clientID, token).then(resp => {
            setListData(resp);
        }).catch(err => {
            console.error(err);
        }).finally(() => setIsReload(false))
        return () => {

        }
    }, [isReload])
    return (
        <Row>
            <Col xs={12}>
                {!isReload && (
                    <ReactHTMLTableToExcel
                        className="buttonExportExcel"
                        table="exportData"
                        filename="Payment"
                        sheet="Sheet1"
                        buttonText=" Export Excel " />
                )}
                <Table id="exportData" striped bordered hover responsive="lg" style={{ display: "none" }}>
                    <thead>
                        <tr className="colorWhite bgHeaderTabel tabelCenter">
                            <th>Kode Payment</th>
                            <th>Nama Payment</th>
                            <th>Jumlah pembayaran diisi sistem secara otomatis saat pembayaran</th>
                            <th>mbayaran menggunkan mesin EDC</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listData.map((el, i) => {
                            return (
                                <tr key={i}>
                                    <td>{el.kodepayment}</td>
                                    <td>{el.namapayment}</td>
                                    <td>{el.isAutoFill ? "TRUE":"FALSE"}</td>
                                    <td>{el.isCard ? "TRUE":"FALSE"}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </Col>
        </Row>
    );
}
export default Export;